<template>
  <!-- eslint-disable -->
  <div class="flex column">
    <h3 class="explanation-results-header">
      Differences
    </h3>
    <div v-for="(result, idx) in item" :key="idx">
      <div class="explanation-results-wrapper">
        <div>
          <span class="q-mt-nome case-header">
            Case {{ idx + 1 }}
          </span>
        </div>
        <div class="results-wrapper">
          <div v-for="(explanationFormated, index ) in result" :key="index">
            <div class="explanation-similar-results-wrapper">
            <span>
            {{ parseInt(index) + 1 }}
            </span>
              <div v-html="explanationFormated.formattedExplanation">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BomValidationSimilarSolutions',
    props: {
      item: {
        type: Object,
        required: true
      },
      itemIndex: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .explanation-results-header {
    margin: 5px;
  }

  .explanation-results-wrapper {
    padding: 20px 20px 40px;
    border-bottom: 2px solid #738497;
  }

  .explanation-similar-results-wrapper {
    display: flex;
    flex-direction: row;
    color: #5b7085;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3rem;
    gap: 8px;
  }

  .case-header {
    display: flex;
    justify-content: flex-end;
    margin: 0 0 8px;
    font-size: 14px;
    color: #545454;
    font-weight: 500;
  }

  .results-wrapper {
    background: #eaedf366;
    padding: 8px;
  }
</style>
